import { ICustomPlanResponse, IPlanResponse } from "./service";
import {
  isPredefinedVersion,
  IVersionWithPrice,
  PricingPeriodEnum,
  PricingPlanVersionEnum,
  VersionWithPriceMapType,
} from "./types";

/**
 * 获取个人端网址
 * @returns
 */
export const getplatformUrl = () => {
  const host = window.location.host;
  if (host.startsWith("dev")) {
    return "https://devplatform.12times.com";
  } else if (host.startsWith("qas")) {
    return "https://qasplatform.12times.com";
  } else {
    return "https://platform.12times.com";
  }
};

export const getOfficialWebsiteUrl = () => {
  const host = window.location.host;
  if (host.startsWith("dev")) {
    return "https://devweb.12times.com";
  } else if (host.startsWith("qas")) {
    return "https://qasweb.12times.com";
  } else {
    return "https://web.12times.com";
  }
};

/**
 * 判断是否在c端环境
 * @returns
 */
export const isInPlatform = () => {
  const host = window.location.host;
  return (
    host.startsWith("platform") ||
    host.startsWith("qasplatform") ||
    host.startsWith("devplatform") ||
    host.startsWith("uatplatform") ||
    host.startsWith("localhost")
  );
};

/**
 * 根据 id 获取版本信息
 * @param id
 * @param versionWithPrice
 * @returns
 */
export const getVersionById = (
  id: string,
  versionWithPrice: IVersionWithPrice[]
) => {
  return (
    versionWithPrice.find((item) => item.monthlyId === id) ||
    versionWithPrice.find((item) => item.yearlyId === id)
  );
};

/**
 * 根据版本和周期获取价格
 * @param priceInformation
 * @param version
 * @param period
 * @returns
 */
export const getPriceByVersionAndPeriod = (
  priceInformation: VersionWithPriceMapType,
  version: PricingPlanVersionEnum,
  period: PricingPeriodEnum
) => {
  if (!priceInformation[version]) {
    return 0;
  }

  switch (period) {
    case PricingPeriodEnum.MONTHLY:
      return priceInformation[version].monthlyPrice;
    case PricingPeriodEnum.YEARLY:
      return priceInformation[version].yearlyPrice;
  }
};

/**
 * 将计划响应转换为版本价格映射
 * @param planResponse
 * @returns
 */
export const transformPlanResponseToVersionWithPriceMap = (
  planResponse: (IPlanResponse | ICustomPlanResponse)[]
) => {
  const isCustomePlan = planResponse.every(
    (item) => !isPredefinedVersion(item.memberPlan)
  );

  // 自定义版本计算
  if (isCustomePlan) {
    const planVersion = planResponse[0].memberPlan;
    const result: Record<string, Partial<IVersionWithPrice>> = {
      [planVersion]: {
        version: planVersion,
        versionNum: 1,
        label: planVersion,
      },
    };

    planResponse.forEach((item) => {
      if (item.timeUnit === "MONTH") {
        result[planVersion] = {
          ...result[planVersion],
          monthlyId: item.goodsId,
          monthlyPrice: item.amount,
        };
      }

      if (item.timeUnit === "YEAR") {
        result[planVersion] = {
          ...result[planVersion],
          yearlyId: item.goodsId,
          yearlyPrice: item.amount,
          yearlyPayTip: `立省 ${item.discountAmount} 元`,
        };
      }
    });

    return result as VersionWithPriceMapType;
  }

  const result: Record<PricingPlanVersionEnum, Partial<IVersionWithPrice>> = {
    [PricingPlanVersionEnum.BASIC]: {
      version: PricingPlanVersionEnum.BASIC,
      versionNum: 1,
      label: "Basic",
    },
    [PricingPlanVersionEnum.PLUS]: {
      version: PricingPlanVersionEnum.PLUS,
      versionNum: 2,
      label: "Plus",
    },
    [PricingPlanVersionEnum.PRO]: {
      version: PricingPlanVersionEnum.PRO,
      versionNum: 3,
      label: "Pro",
    },
    [PricingPlanVersionEnum.ULTRA]: {
      version: PricingPlanVersionEnum.ULTRA,
      versionNum: 4,
      label: "Ultra",
    },
  };

  planResponse.forEach((item) => {
    if (item.timeUnit === "MONTH") {
      result[item.memberPlan as PricingPlanVersionEnum] = {
        ...result[item.memberPlan as PricingPlanVersionEnum],
        monthlyId: item.goodsId,
        monthlyPrice: item.amount,
      };
    }

    if (item.timeUnit === "YEAR") {
      result[item.memberPlan as PricingPlanVersionEnum] = {
        ...result[item.memberPlan as PricingPlanVersionEnum],
        yearlyId: item.goodsId,
        yearlyPrice: item.amount,
        yearlyPayTip: `立省 ${item.discountAmount} 元`,
      };
    }
  });

  return result as VersionWithPriceMapType;
};

/**
 * 将版本价格映射转换为数组
 * @param versionWithPriceMap
 * @returns
 */
export const transformVersionWithPriceMapToArray = (
  versionWithPriceMap: VersionWithPriceMapType
) => {
  return Object.values(versionWithPriceMap);
};
